const formController = require("../../../utilities/_form-controller");

/**
 * @param formData {object}
 * @returns {Promise<void>}
 */
module.exports = async function submitFormToMarketo(formData) {
    await formController.marketo__submit(formData, false, undefined, undefined);
}